export default (state) => (Object.keys(state.user.data).length > 0 ? state.user.data : null)
